import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import PreviewCard from '../shared/preview_card.jsx';
import { requestGet } from '../../../../modules/request';

const TeacherCenterArticleCard = ({ blogPostId, color }) => {
  const [blogPost, setBlogPost] = React.useState(null);
  const [blogPostAuthor, setBlogPostAuthor] = React.useState(null);

  React.useEffect(() => {
    getBlogPost(blogPostId)
  }, [])

  function getBlogPost(id: string) {
    requestGet(`/featured_blog_post/${id}`,
      (data) => {
        if(data.blog_post) {
          const { blog_post, author } = data;
          setBlogPost(blog_post)
          setBlogPostAuthor(author)
        }
      }
    )
  }

  function renderPreviewContent({ title, slug, preview_card_content, external_link, footer_content }) {
    if (footer_content) {
      return(
        <section className="content-section">
          <h4>{title}</h4>
          <div className="preview-card">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{footer_content}</ReactMarkdown>
          </div>
          <section className="footer-section">
            {blogPostAuthor && <p className="author">{`By ${blogPostAuthor}`}</p>}
            <a className="quill-button focus-on-light contained teal extra-small" href={`/teacher-center/${slug}`} rel="noopener noreferrer" target="_blank">Read</a>
          </section>
        </section>
      )
    }

    return(
      <PreviewCard
        color={color}
        content={preview_card_content}
        externalLink={!!external_link}
        key={title}
        link={external_link ? external_link : `/teacher-center/${slug}`}
      />
    )
  }

  if(!blogPost) { return <span /> }

  return renderPreviewContent(blogPost)
}

const SubjectPageTeacherCenterArticles = ({ blogPostIds, color }) => (
  <section className="teacher-center-articles">
    <div className="container">
      <h2>Learn more with these Teacher Center articles</h2>
      <div className="articles-wrapper">
        {blogPostIds.map(id => (
          <TeacherCenterArticleCard blogPostId={id} color={color} key={id} />
        ))}
      </div>
    </div>
  </section>
)

export default SubjectPageTeacherCenterArticles
